import React from 'react';

const StatCard = ({ value, label, color = 'text-brand-500', bg = 'bg-white', emoji }) => {
  return (
    <div className={`${bg} rounded-xl p-4 border border-stone-200 text-center shadow-sm`}>
      {emoji && <div className="text-2xl mb-1">{emoji}</div>}
      <div className={`text-3xl font-bold ${color} mb-1`}>{value}</div>
      <p className="text-xs text-stone-600 leading-tight">{label}</p>
    </div>
  );
};

export default StatCard;
